const AccessDeniedPage = () => {
  return (
    <div
      style={{

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <h1 style={{ color: 'black' }}>Access Denied</h1>
    </div>
  );
};

export default AccessDeniedPage;
